import DeliveryAdressesList from './DeliveryAdressesList';
import { CustomPageHeader, Text } from '@src/components';
import { useText } from '@src/components';
const DeliveryAddresses = () => {
  const companyInformation2 = useText('companyInformation2');
  return (
    <CustomPageHeader
      data-testid="delivery-adresses"
      title={<Text t="deliveryAddresses" />}
      showBreadCrumb
      showHelpButton
      routes={[companyInformation2]}
    >
      <DeliveryAdressesList />
    </CustomPageHeader>
  );
};

export default DeliveryAddresses;
